// @flow strict
import * as React from 'react';

/**
 * @ignore
 */
export const TriangleUp = (): React.Element<*> => (
  <path d="M9.564 4.759l-5.5 10c-0.039 0.070-0.062 0.153-0.062 0.241 0 0.276 0.223 0.5 0.499 0.5h11c0.276-0 0.499-0.224 0.499-0.5 0-0.088-0.023-0.171-0.063-0.243l0.001 0.003-5.5-10c-0.087-0.156-0.25-0.259-0.438-0.259s-0.351 0.103-0.437 0.256l-0.001 0.003z"></path>
);
